export default __webpack_public_path__ + "static/Card11-c4f67fb08ecbcb8c8636187fe4c8b7af.png";